import api from "./Api";
import { BASE_URL } from "./Context/config";

export interface PutUserData {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  category: string;
  role?: string;
}

export interface PutProfileData {
  id: number;
  userId: number;
  userName: string;
  birthDate: string;
  gender: string;
  profilePicture?: string;
  profileCoverPicture?: string;
  profilePictureFrame: 0;
  occupation: string;
  isPremium: boolean;
  isSearch: boolean;
  country: string;
  keywords?: string;
}

export const GetProfile = async () => {
  try {
    const response = await api.get(`${BASE_URL}/Profile/GetProfile`, {
      headers: {
        withCredentials: true,
      },
    });

    return response;
  } catch (error) {
    return { error: error.message };
  }
};

export const GetProfilesFromLink = async (search: string) => {
  try {
    const response = await api.get(
      `${BASE_URL}/Profile/GetProfilesFromLink/` + search,
      {
        headers: {
          "Cache-Control": "public,max-age=3600",
          Pragma: "",
        },
      }
    );

    return response;
  } catch (error) {
    return { error: error.response.data };
  }
};

export const EditProfile = async (
  newUser: PutUserData,
  newProfile: PutProfileData
) => {
  const data: any = {
    Id: newProfile.id,
    UserId: newProfile.userId,
    UserName: newProfile.userName,
    FirstName: newUser.firstName,
    LastName: newUser.lastName,
    BirthDate: newProfile.birthDate,
    Gender: newProfile.gender,
    ProfilePictureFrame: newProfile.profilePictureFrame,
    Occupation: newProfile.occupation,
    isPremium: newProfile.isPremium,
    Country: newProfile.country,
    isSearch: newProfile.isSearch,
    Keywords: newProfile.keywords,
  };

  // Only include profile picture if it exists
  if (newProfile.profilePicture) {
    data.ProfilePicture = newProfile.profilePicture;
  }

  // Only include cover picture if it exists (optional)
  if (newProfile.profileCoverPicture) {
    data.ProfileCoverPicture = newProfile.profileCoverPicture;
  }

  if (newProfile.isSearch === true) data.isSearch = true;
  else data.isSearch = false;

  try {
    const response = await api.put(`${BASE_URL}/Profile/EditProfile`, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.status === 200) {
      return response;
    } else {
      throw new Error(`Server returned status ${response.status}`);
    }
  } catch (error) {
    console.error("EditProfile Error:", error);

    if (error.response) {
      // Server responded with error status
      const errorMessage = error.response.data?.error || error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(errorMessage);
    } else if (error.request) {
      // Network error
      throw new Error("Network error: Unable to connect to server");
    } else {
      // Other error
      throw new Error(error.message || "Unknown error occurred");
    }
  }
};
